import { render, staticRenderFns } from "./QrColorPicker.vue?vue&type=template&id=2e0cf94e&scoped=true"
import script from "./QrColorPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./QrColorPicker.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./QrColorPicker.vue?vue&type=style&index=0&id=2e0cf94e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0cf94e",
  null
  
)

export default component.exports